/**
 * Attaches the updaters a kind supports to its teardown.
 *
 * Not on the package entry: a consumer receives the result, it does not build one. The two types
 * above are what a consumer needs, and they are public.
 */
export function withControls(teardown, controls) {
    return Object.assign(teardown, controls);
}
